import {
	SMALL_DEVICE_WIDTH_MAX,
	MEDIUM_PORTRAIT_WIDTH_MAX,
	MEDIUM_DEVICE_WIDTH_MAX,
	LARGE_DEVICE_WIDTH_MAX,
	MOBILE_DEVICE_MAX_WIDTH,
	TABLET_DEVICE_MAX_WIDTH,
	DESKTOP_DEVICE_MAX_WIDTH,
	LARGE_DESKTOP_DEVICE_MAX_WIDTH,
} from "@consts";

export default {
	computed: {
		isSmallDevice() {
			if (!process.client) {
				return true;
			}
			return (
				this.$store.state.window.windowWidth <= SMALL_DEVICE_WIDTH_MAX
			);
		},
		isMediumPortraitDevice() {
			if (!process.client) {
				return false;
			}
			return (
				this.$store.state.window.windowWidth <=
					MEDIUM_PORTRAIT_WIDTH_MAX &&
				this.$store.state.window.windowWidth > SMALL_DEVICE_WIDTH_MAX
			);
		},
		isMediumDevice() {
			if (!process.client) {
				return false;
			}
			return (
				this.$store.state.window.windowWidth <=
					MEDIUM_DEVICE_WIDTH_MAX &&
				this.$store.state.window.windowWidth > SMALL_DEVICE_WIDTH_MAX
			);
		},
		isSmallOrMediumPortraitDevice() {
			return this.isSmallDevice || this.isMediumPortraitDevice;
		},
		isSmallOrMediumDevice() {
			return this.isSmallDevice || this.isMediumDevice;
		},
		isLargeDevice() {
			return (
				!this.isSmallOrMediumDevice &&
				this.$store.state.window.windowWidth <= LARGE_DEVICE_WIDTH_MAX
			);
		},
		isExtraLargeDevice() {
			if (!process.client) {
				return false;
			}
			return (
				this.$store.state.window.windowWidth > LARGE_DEVICE_WIDTH_MAX
			);
		},
		isMediumDeviceOrWider() {
			if (!process.client) {
				return false;
			}

			return !this.isSmallDevice;
		},
		isMediumLandscapeDeviceOrWider() {
			return !this.isSmallOrMediumPortraitDevice;
		},
		isLargeDeviceOrWider() {
			return !this.isSmallOrMediumDevice;
		},
		isMinHeightScreen() {
			if (!process.client) {
				return true;
			}
			return (
				this.$store.state.window.windowHeight !== null &&
				this.$store.state.window.windowHeight >= 520
			);
		},
		isMobileDevice() {
			if (!process.client) {
				return true;
			}
			return (
				this.$store.state.window.windowWidth !== null &&
				this.$store.state.window.windowWidth <= MOBILE_DEVICE_MAX_WIDTH
			);
		},
		isTabletDevice() {
			if (!process.client) {
				return false;
			}
			return (
				this.$store.state.window.windowWidth !== null &&
				!this.isMobileDevice &&
				this.$store.state.window.windowWidth <= TABLET_DEVICE_MAX_WIDTH
			);
		},
		isDesktopDevice() {
			if (!process.client) {
				return false;
			}
			return (
				!this.isMobileDevice &&
				!this.isTabletDevice &&
				this.$store.state.window.windowWidth > DESKTOP_DEVICE_MAX_WIDTH
			);
		},
		isLargeDesktopDevice() {
			if (!process.client) {
				return false;
			}
			return (
				!this.isMobileDevice &&
				!this.isTabletDevice &&
				!this.isDesktopDevice &&
				this.$store.state.window.windowWidth >
					LARGE_DESKTOP_DEVICE_MAX_WIDTH
			);
		},
		isOrientationPortrait() {
			if (!process.client) {
				return true;
			}

			if (
				this.$store.state.window.windowWidth === null ||
				this.$store.state.window.windowHeight === null
			) {
				return true;
			}

			return (
				this.$store.state.window.windowWidth <
				this.$store.state.window.windowHeight
			);
		},
		isOrientationLandscape() {
			if (!process.client) {
				return false;
			}

			return (
				this.$store.state.window.windowWidth >=
				this.$store.state.window.windowHeight
			);
		},
	},
};
